export const ariaLabel = {
    price: { min: 'Minimum price', max: 'Maximum price' },
    deposit: 'Deposit',
    monthlyPrice: { min: 'Minimum monthly price', max: 'Maximum monthly price' },
    engineSize: { min: 'Minimum engine size', max: 'Maximum engine size' },
    enginePower: { min: 'Minimum engine power', max: 'Maximum engine power' },
    year: { min: 'Minimum year manufactured', max: 'Maximum year manufactured' },
    seats: { min: 'Minimum belted seats', max: 'Maximum belted seats' },
    length: { min: 'Minimum exterior length', max: 'Maximum exterior length' },
    mileage: { min: 'Minimum mileage', max: 'Maximum mileage' },
    mileageFinance: 'Mileage',
    mtplm: {
        min: 'Maximum Technically Permitted Laden Mass - minimum',
        max: 'Maximum Technically Permitted Laden Mass - maximum',
    },
    hours: {
        min: 'Minimum hours used',
        max: 'Maximum hours used',
    },
    gvw: {
        min: 'Minimum gross vehicle weight',
        max: 'Maximum gross vehicle weight',
    },
    gtw: {
        min: 'Minimum gross trailer weight',
        max: 'Maximum gross trailer weight',
    },
    frameSize: {
        min: 'Minimum frame size',
        max: 'Maximum frame size',
    },
}
